// modal-template-password-reset.js
import axios from 'axios';

const classPrefix = 'modal-template-password-reset';
const dataPrefix = 'data-modal-template-password-reset';
import { input } from '../../input/input';
export function modalTemplatePasswordReset($container, params = {}) {
    const $template = document.querySelector(`[${dataPrefix}-template]`)

    init();
    function init(){
        const $modalClone = document.importNode($template.content, true)

        const $form = $modalClone.querySelector(`[${dataPrefix}-form]`);
        const $confirm = $modalClone.querySelector(`[${dataPrefix}-confirm]`);

        // Добавим скрытое поле profile до рендера видимых полей
        ensureProfileField($form, params.profile);

        renderFields($form)
        ensureStatusField($form);
        $confirm.addEventListener('click', () => {
            submitForm($form, $confirm);
        });

        $container.appendChild($modalClone)
    }

    function ensureProfileField($form, profileValue) {
        // если уже есть — обновим, иначе добавим скрытое поле
        let $existing = $form.querySelector('input[name="profile"]');
        if ($existing) {
            $existing.value = profileValue || '';
            return;
        }
        const $hidden = document.createElement('input');
        $hidden.type = 'hidden';
        $hidden.name = 'profile';
        $hidden.value = profileValue || '';
        $form.appendChild($hidden);
    }


    function renderFields($form) {
        // очищаем от предыдущих (но не трогаем скрытое поле)
        // удаляем все children кроме скрытого profile
        const profileInput = $form.querySelector('input[name="profile"]');
        $form.innerHTML = '';
        if (profileInput) $form.appendChild(profileInput);

        input($form, {
            type: 'password',
            label: "Пароль",
            name: 'password',
            required: true,
        });
    }

    function ensureStatusField($form) {
        // общий статус/ошибка
        let $status = $form.querySelector(`.${classPrefix}__status`);
        if (!$status) {
            $status = document.createElement('div');
            $status.className = `${classPrefix}__status`;
            $form.appendChild($status);
        }
    }
    function setStatusMessage($form, message, isError = true) {
        const $status = $form.querySelector(`.${classPrefix}__status`);
        if (!$status) return;
        $status.textContent = message || '';
        $status.style.display = message ? 'block' : 'none';
        $status.classList.toggle('is-error', isError);
    }
    function clearErrors($form) {
        // удаляем старые текстовые сообщения ошибок под input'ами
        $form.querySelectorAll(`.${classPrefix}__field-error`).forEach(e => e.remove());
        setStatusMessage($form, '');
        // сброс состояния инпутов
        $form.querySelectorAll('input, textarea').forEach(el => {
            el.classList.remove('is-invalid');
        });
    }

    // главная функция отправки
    async function submitForm($form, $confirmBtn) {
        clearErrors($form);
        setStatusMessage($form, '');

        // собираем поля по имени (включая скрытый profile)
        const payload = {};
        $form.querySelectorAll('input[name], textarea[name]').forEach(($el) => {
            const name = $el.getAttribute('name');
            payload[name] = $el.value;
        });

        // UI: блокировка кнопки
        const oldBtnText = $confirmBtn.textContent;
        $confirmBtn.setAttribute('disabled', 'true');
        $confirmBtn.classList.add('is-loading');
        $confirmBtn.textContent = 'Обработка...';

        const metaToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        if (metaToken) {
            axios.defaults.headers.common['X-CSRF-TOKEN'] = metaToken;
        }

        try {
            const response = await axios.post('/restore-password', payload);

            const redirectTo = response.data?.redirect || response.data?.url;
            if (redirectTo) {
                window.location.href = redirectTo;
                return;
            }

            document.dispatchEvent(new CustomEvent('modal-template:close'));
            document.dispatchEvent(new CustomEvent('modal-template:notify', {detail: {text: 'Пароль успешно изменен'}}));

        } catch (error) {
            const msg = error?.response?.data?.message || 'Ошибка';
            setStatusMessage($form, msg, true);
            console.error(error);
        } finally {
            $confirmBtn.removeAttribute('disabled');
            $confirmBtn.classList.remove('is-loading');
            $confirmBtn.textContent = oldBtnText;
        }
    }
}
